/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WaterfallInvestedCapitalTotal = {
  owner_type: WaterfallInvestedCapitalTotal.owner_type;
  owner_id: number;
  invested_capital: string;
  realized_value: string;
};
export namespace WaterfallInvestedCapitalTotal {
  export enum owner_type {
    FUND = 'fund',
    RELATED_ENTITY = 'related_entity',
  }
}

